import React, { useState } from 'react'
import GWPlaceHolder from '../../assets/gw_placeholder.png'
import GrowthWheelModalVisualizer from './growth-wheel-modal-visualizer'

interface GWVisualizerProps {
  imageUrl?: string
}

const GrowthWheelVisualizer = ({ imageUrl = GWPlaceHolder }: GWVisualizerProps) => {

  const [isFullscreen, setIsFullscreen] = useState(false)

  return (
    <>
      <div className="card shadow-sm border-0 rounded-3 gw-visualizer-card">
        <div className="card-body p-4 d-flex flex-column gap-3">
          <h5 className="mb-0 fw-semibold text-dark">Assessment Overview</h5>

          <div className="position-relative d-flex justify-content-center">
            <button
              type="button"
              onClick={() => setIsFullscreen(true)}
              className="p-0 border-0 bg-transparent"
              aria-label="View Growth Wheel fullscreen"
            >
              <div
                className="rounded-3 bg-white"
                style={{
                  width: '306px',
                  height: '306px',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={imageUrl}
                  alt="Growth Wheel"
                  className="img-fluid h-100 w-100"
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      {isFullscreen && (
        <GrowthWheelModalVisualizer imageUrl={imageUrl} show={isFullscreen} onClose={() => setIsFullscreen(false)} />
      )}
    </>
  )
}

export default GrowthWheelVisualizer